<div class="dialog-wrapper">
    <!-- <div class="icon-wrapper">
        <i class="icon icon-status" [inlineSVG]="'#check-success'"></i>
    </div> -->
    <div mat-dialog-title class="title-wrapper">
        <h2 class="status-title">{{ data.title | translate }}</h2>

        <p class="status-text" *ngIf="data.text">{{data.text}}</p>
    </div>


</div>


<div mat-dialog-actions>
    <div class="nav-container">
        <button class="btn primary" (click)="close()" mat-flat-button>{{ 'OK' | translate }}</button>
    </div>
</div>